module.exports = __webpack_public_path__ + "media/images/stripe/light-on-light@3x-65c77ad80285b960334a754537e001d2.png";